(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationTopicCategory', CommunicationTopicCategory);

    CommunicationTopicCategory.$inject = ['$resource'];

    function CommunicationTopicCategory ($resource) {
        var resourceUrl =  'api/communication-topic-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
